module.exports = __webpack_public_path__ + "assets/38f188be903a073e462d8b25324ac43f.mp3";